import { format } from "date-fns";
import { nn } from "date-fns/locale";
import { WHOLE } from "@/components/admin/calendar/engine";
import { capitalize, fmtRange, fmtTime } from "@/lib/format";

/** Flat, pre-formatted rows for print and PDF: same entries, order and «I dag» divider as the on-screen terminliste. */
export const terminlisteRows = (entries, { today, roomName }) => {
  const isPast = (e) => today && (e.end_date || e.start_date) < today;
  const rows = [];
  entries.forEach((e, i) => {
    if (i > 0 && !isPast(e) && isPast(entries[i - 1])) {
      rows.push({ id: `${e.id}-today`, divider: `I dag · ${capitalize(format(new Date(), "EEEE d. MMMM", { locale: nn }))}` });
    }
    rows.push({
      id: e.id,
      date: fmtRange(e.start_date, e.end_date),
      time: fmtTime(e.start_time, e.end_time),
      title: e.title || "",
      subtitle: [e.category && e.category !== e.title ? e.category : null, e.organizer].filter(Boolean).join(" · "),
      notes: e.notes || "",
      rooms: e.room_ids?.includes(WHOLE) ? "Heile huset" : (e.room_ids || []).map(roomName).join(", "),
      contact: [e.contact_name, e.contact_phone].filter(Boolean).join(" · "),
      visibility: e.visibility === "public" ? "Ope" : "Privat",
    });
  });
  return rows;
};

export const terminlisteMeta = ({ scopeLabel, filterLabels = [], count }) =>
  [scopeLabel, ...filterLabels, `${count} ${count === 1 ? "oppføring" : "oppføringar"}`].filter(Boolean).join(" · ");

export const printedLabel = () => format(new Date(), "d. MMMM yyyy", { locale: nn });
